/**
 * Party characteristics Residence history section
 */
import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const ResidenceHistoriesState = {
  residenceHistories: [],
  preConvertedResidenceHistories: [],
  saveResidenceHistoriesTriggered: false,
}

export const ResidenceHistoriesActions = {
  createResidenceHistory ({ commit }, req) {
    return axiosRequest.
      post(`/parties/${req.party_id}/residence_histories`, { residence_history: req }).
      then(({ data }) => {
        commit('setResidenceHistories', data.residence_histories)
      }).
      catch(handleError)
  },

  fetchResidenceHistories: async ({ commit }, req) => {
    return axiosRequest.
      get(`/parties/${req.partyId}/residence_histories`).
      then(({ data }) => {
        commit('setResidenceHistories', data.residence_histories)
        commit('setPreConvertedResidenceHistories', [])
      }).
      catch(handleError)
  },

  saveResidenceHistory ({ commit }, req) {
    return axiosRequest.
      patch(`/parties/${req.party_id}/residence_histories/${req.id}`, { residence_history: req }).
      then(({ data }) => {
        commit('setResidenceHistories', data.residence_histories)
      }).
      catch(handleError)
  },
}

export const ResidenceHistoriesMutations = {
  setNewResidenceHistory: (state, payload) => {
    const residenceHistory = {
      non_us_data: null,
      address: null,
      city: null,
      county: null,
      state: null,
      zip: null,
      int_state: null,
      int_zip: null,
      country_id: null,
      start_date: null,
      start_date_format: null,
      start_date_uncertain: null,
      end_date: null,
      end_date_format: null,
      end_date_uncertain: null,
      party_id: payload.partyId,
    }
    state.residenceHistories.push(residenceHistory)
  },
  setPreConvertedNewResidenceHistory: (state, payload) => {
    state.preConvertedResidenceHistories.push(payload.data)
    state.residenceHistories.push(payload.data)
  },
  setResidenceHistories: (state, payload) => { state.residenceHistories = payload },
  setResidenceHistory: (state, payload) => { if (payload.index !== -1) Vue.set(state.residenceHistories, payload.index, payload.data) },
  setResidenceHistoriesSaveTriggered: (state, payload) => {
    state.saveResidenceHistoriesTriggered = payload
  },
  setPreConvertedResidenceHistories: state => {
    const rhs = state.residenceHistories
    const crhs = state.preConvertedResidenceHistories
    state.residenceHistories = rhs.concat(crhs)
  },
}

export const ResidenceHistoriesGetters = {
  getResidenceHistories: state => state.residenceHistories,
  getPreConvertedResidenceHistories: state => state.preConvertedResidenceHistories,
  getSaveResidenceHistoryTriggered: state => state.saveResidenceHistoriesTriggered,
}
